module.exports = __webpack_public_path__ + "img/customer-service.ab23eda.svg";